import { useState } from "react";
import { buildStorageUrl } from "config/clientConfig";

const money = (value) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(value) || 0);

const resolveImagePath = (image) => {
  if (!image) return "";
  const rawImage = String(image);
  if (/^https?:\/\//i.test(rawImage) || rawImage.startsWith("images/") || rawImage.startsWith("storage/") || rawImage.startsWith("products/")) {
    return rawImage;
  }
  return `images/${rawImage}`;
};

function ImagePlaceholder() {
  return (
    <div data-testid="order-item-image-placeholder" className="w-full h-full flex items-center justify-center text-gray-400">
      <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
        <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
      </svg>
    </div>
  );
}

export default function OrderItemCard({ item }) {
  const [imageFailed, setImageFailed] = useState(false);
  const quantity = Number(item?.qty) || 0;
  const unitPrice = Number(item?.sellingPrice) || 0;
  const productName = item?.product?.name || `#${item?.productId ?? "-"}`;
  const imagePath = resolveImagePath(item?.product?.image);
  const imageUrl = imagePath ? buildStorageUrl(imagePath) : "";

  return (
    <div className="flex items-center gap-3 rounded-2xl border border-gray-200 bg-white p-3 shadow-sm">
      <div className="w-16 h-16 sm:w-20 sm:h-20 flex-shrink-0 overflow-hidden rounded-lg bg-gray-100">
        {imageUrl && !imageFailed ? (
          <img src={imageUrl} alt={productName} className="w-full h-full object-cover" onError={() => setImageFailed(true)} />
        ) : (
          <ImagePlaceholder />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="font-semibold text-gray-900 truncate">{productName}</h3>
        <p className="mt-1 text-sm text-gray-500">{quantity} × {money(unitPrice)}</p>
      </div>
      <span className="flex-shrink-0 font-bold text-gray-900">{money(quantity * unitPrice)}</span>
    </div>
  );
}
